import React from "react";

export const OtherMusic = ({size = 20, ...props}) => {
	return (
		<svg viewBox="0 0 512 512" width={size} height={size} xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M48.696 368.157a7.728 7.728 0 01-2.737-14.957l182.939-69.23a7.728 7.728 0 015.47 14.454l-182.939 69.23c-.9.342-1.825.503-2.733.503z"
				fill="#ff6e80"
			/>
			<path
				d="M106.67 460.481l-45.425 10.152-32.148-143.844 38.657-40.435z"
				fill="#db2a17"
			/>
			<path
				d="M266.459 392.974l-45.425 10.152-37.224-166.557 50.501 12.56z"
				fill="#f9475e"
			/>
			<path
				d="M234.312 249.129l-121.915 46.137-39.327 14.887h-.01l-28.23-1.999-15.733 18.638-10.406-46.59c-3.359-15.012 4.832-30.209 19.215-35.648l56.326-21.317L184.723 189c17.587-6.666 36.998 3.802 41.099 22.162z"
				fill="#ff6e80"
			/>
			<path
				d="M112.396 295.265l-83.3 31.527-10.406-46.59c-3.359-15.012 4.832-30.209 19.215-35.648l56.326-21.317c-2.844 6.233-4.976 15.846-2.401 29.58l7.016 30.651c.002.001 1.949 10.695 13.55 11.797z"
				fill="#f9475e"
			/>
			<path
				d="M222.278 442.588c-.113.031-.237.051-.35.082-29.271 6.542-56.79-5.1-61.457-26.005-4.513-20.163 13.878-41.573 41.439-48.939 1.02-.278 2.05-.525 3.091-.762 29.271-6.543 56.79 5.1 61.457 26.015 4.656 20.822-15.116 42.974-44.18 49.609z"
				fill="#ff6e80"
			/>
			<path
				d="M222.278 442.588c-.113.031-.237.051-.35.082-29.271 6.542-56.79-5.1-61.457-26.005-4.513-20.163 13.878-41.573 41.439-48.939-4.916 16.207-12.633 55.574 20.368 74.862zM62.138 510.176c-.103.02-.216.051-.319.072-29.147 6.388-56.491-5.244-61.138-26.077-4.482-20.05 13.672-41.336 40.975-48.815a75.29 75.29 0 013.554-.886c29.271-6.542 56.79 5.111 61.457 26.015 4.678 20.904-15.268 43.148-44.529 49.691z"
				fill="#f9475e"
			/>
			<path
				d="M61.819 510.248c-29.147 6.388-56.491-5.244-61.138-26.077-4.482-20.05 13.672-41.336 40.975-48.815-4.853 14.31-13.116 51.298 20.163 74.892z"
				fill="#db2a17"
			/>
			<path
				d="M504.123 184.711c-2.126 4.641-8.999 3.699-9.765-1.348-3.641-23.993-18.575-48.139-52.126-69.717a122.115 122.115 0 01-13.518-10.043c-9.465-8.124-24.135-2.463-25.478 9.938l-15.565 141.6-31.553 5.238 26.448-244.195C383.644 6.227 392.59-.97 402.547.108c7.193.779 13.214 5.759 15.368 12.666 4.294 13.762 15.593 37.516 44.755 56.275 8.392 5.395 15.619 10.951 21.796 16.625 27.378 25.15 35.143 65.238 19.657 99.037z"
				fill="#2a4f95"
			/>
			<path
				d="M387.672 255.145c-2.72 25.098-31.589 42.654-64.909 39.759a99.907 99.907 0 01-1.803-.175c-34.072-3.689-59.459-27.395-56.687-52.957 2.771-25.551 32.64-43.283 66.712-39.584l.525.062c33.804 3.874 58.923 27.468 56.162 52.895z"
				fill="#4a66a0"
			/>
			<path
				d="M322.763 294.904a99.907 99.907 0 01-1.803-.175c-34.072-3.689-59.459-27.395-56.687-52.957 2.771-25.551 32.64-43.283 66.712-39.584l.525.062c-10.643 12.806-32.846 47.476-8.747 92.654z"
				fill="#2a4f95"
			/>
			<path
				d="M401.024 487.117l-47.456 22.811a20.89 20.89 0 01-13.981 1.484c-5.893-1.432-11.127-5.398-13.961-11.292l-22.811-47.445c-7.542-15.702-.938-34.546 14.764-42.088a31.455 31.455 0 0113.631-3.122c11.745 0 23.017 6.594 28.447 17.886l.804 1.669.731 1.514a6.987 6.987 0 009.324 3.277l3.184-1.535c15.702-7.552 34.546-.937 42.088 14.764 7.542 15.691.938 34.536-14.764 42.077z"
				fill="#ffbed8"
			/>
			<path
				d="M339.587 511.412c-5.893-1.432-11.127-5.398-13.961-11.292l-22.811-47.445c-7.542-15.702-.938-34.546 14.764-42.088a31.455 31.455 0 0113.631-3.122c11.745 0 23.017 6.594 28.447 17.886l.804 1.669c-11.838 4.039-38.44 20.431-20.874 84.392z"
				fill="#ff97c1"
			/>
			<path
				d="M284.6 87.876l-23.45 41.964a18.955 18.955 0 01-7.119 7.223c-5.636 3.266-12.796 3.554-18.896.144l-41.964-23.439c-13.878-7.758-18.844-25.304-11.086-39.183 5.275-9.438 15.063-14.754 25.16-14.754 4.492 0 9.056 1.061 13.301 3.287.237.124.474.247.711.381l2.823 1.576a6.38 6.38 0 008.675-2.463l1.576-2.813c7.758-13.888 25.294-18.854 39.172-11.096 13.879 7.76 18.845 25.295 11.097 39.173z"
				fill="#ffbed8"
			/>
			<path
				d="M254.031 137.063c-5.636 3.266-12.796 3.554-18.896.144l-41.964-23.439c-13.878-7.758-18.844-25.304-11.086-39.183 5.275-9.438 15.063-14.754 25.16-14.754 4.492 0 9.056 1.061 13.301 3.287-6.243 13.404-14.197 45.632 33.485 73.945z"
				fill="#ff97c1"
			/>
			<path
				d="M106.039 74.658c8.51 12.322-3.73 28.323-17.845 23.357l-15.63-5.502a5.027 5.027 0 00-3.616.093 4.992 4.992 0 00-2.184 1.638l-10.056 13.157c-9.098 11.89-28.096 5.203-27.725-9.767l.402-16.557a5.168 5.168 0 00-3.441-4.986l-15.619-5.502c-14.126-4.967-13.631-25.109.71-29.385l15.877-4.729a5.162 5.162 0 003.678-4.812l.402-16.557C31.229 5.123 39.894-.76 48.167.085c4.131.423 8.16 2.524 10.993 6.625l9.407 13.631a5.15 5.15 0 005.708 2.009l15.877-4.729c14.342-4.286 25.788 12.302 16.691 24.191L96.787 54.969a5.149 5.149 0 00-.144 6.058z"
				fill="#fbf198"
			/>
			<path
				d="M68.949 92.606a4.992 4.992 0 00-2.184 1.638l-10.056 13.157c-9.098 11.89-28.096 5.203-27.725-9.767l.402-16.557a5.168 5.168 0 00-3.441-4.986l-15.619-5.502c-14.127-4.967-13.632-25.109.709-29.385l15.877-4.729a5.162 5.162 0 003.678-4.812l.402-16.557C31.229 5.123 39.894-.76 48.167.085 45.406 10.624 33.98 62.716 68.949 92.606z"
				fill="#fad989"
			/>
			<path
				d="M508.546 353.23c7.253 10.519-3.194 24.191-15.248 19.946l-12.745-4.492-.598-.206a4.393 4.393 0 00-4.956 1.474l-8.582 11.24c-7.768 10.159-23.996 4.441-23.676-8.335l.34-14.146a4.416 4.416 0 00-2.936-4.255l-13.342-4.698c-12.055-4.245-11.632-21.441.618-25.088l13.548-4.049a4.389 4.389 0 003.142-4.1l.34-14.146c.258-10.22 10.849-15.413 18.793-11.683 1.988.927 3.812 2.411 5.265 4.513l8.036 11.643a4.399 4.399 0 004.873 1.721l13.559-4.039c12.25-3.658 22.017 10.499 14.249 20.657l-8.593 11.241a4.394 4.394 0 00-.124 5.162z"
				fill="#fbf198"
			/>
			<path
				d="M480.553 368.685l-.598-.206a4.393 4.393 0 00-4.956 1.474l-8.582 11.24c-7.768 10.159-23.996 4.441-23.676-8.335l.34-14.146a4.416 4.416 0 00-2.936-4.255l-13.342-4.698c-12.055-4.245-11.632-21.441.618-25.088l13.548-4.049a4.389 4.389 0 003.142-4.1l.34-14.146c.258-10.22 10.849-15.413 18.793-11.683-4.688 13.7-15.063 54.511 17.309 77.992z"
				fill="#fad989"
			/>
		</svg>
	);
}

export default OtherMusic;
